import { z } from 'zod/v4';

import { normalizeVideoWidgetArgs } from './video-widget-args.normalization';
import { partialVideoWidgetDataSchema } from './partial-video-widget-data.schema';

/**
 * `data` is the same shared partial `create_video_widget` uses (minus create's required-`url`
 * tightening), kept deliberately identical so a model that has just seen its own create call in the
 * conversation history can pattern-match straight onto this tool.
 */
const updateVideoWidgetObjectSchema = z.object({
    widgetId: z.string().describe('Id of the video widget to update.'),
    data: partialVideoWidgetDataSchema.describe(
        'Partial patch — only the fields you provide are changed, everything else on the widget is left as-is.'
    ),
});

export const updateVideoWidgetArgsSchema = z.preprocess(normalizeVideoWidgetArgs, updateVideoWidgetObjectSchema);
